import { render, staticRenderFns } from "./app-menu.vue?vue&type=template&id=ad98a27e&"
import script from "./app-menu.vue?vue&type=script&lang=ts&"
export * from "./app-menu.vue?vue&type=script&lang=ts&"
import style0 from "./app-menu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports